<template>
	<div class="open-account-bank">

		<van-nav-bar :title="translate('account_bank_title')" fixed />
		
		<van-form @submit="nextStep()" :rules="rules">
			<h4 class="h4_title">{{ translate('bank_upload') }}</h4>
			
			<div style="background-color: #FFFFFF;text-align: center;padding: 20px;">
				<van-image
					width="150"
					height="150"
					:src="bank_front_url"
					@click="call_bank_front_pic"
				/>
			</div>

			<h4 class="h4_title">{{ translate('bank_account_info') }}</h4>

			<van-field
				readonly
				clickable
				:label="translate('open_bank')"
				:value="formItem.bank_name"
				:placeholder="translate('please_select')"
				@click="showBank = true"
				:rules="rules.bank_id"
				required
			/>

			<van-popup v-model="showBank" round position="bottom">
				<van-picker
					:title="translate('open_bank')"
					show-toolbar
					:columns="banks"
					value-key="name"
					:default-index="indexBank"
					@cancel="showBank = false"
					@confirm="onConfirmBank"
				/>
			</van-popup>

			<!-- <van-field 
				v-if="indexBank > -1 && formItem.bank_id == 0"
				v-model="formItem.bank_name" 
				label="其他银行" 
				placeholder="请输入"
				:rules="rules.bank_name"
				required
			/> -->

			<van-field 
				v-model="formItem.bank_branch" 
				:label="translate('branch_bank')" 
				:placeholder="translate('please_branch_bank')"
				:rules="rules.bank_branch"
				required
			/>
			
			<van-field 
				v-model="formItem.bank_number" 
				:label="translate('bank_number')" 
				:placeholder="translate('please_input')"
				:rules="rules.bank_number"
				required
			/>

			<div class="submit-button">
				<van-button type="warning" block round color="#224A9F" native-type="submit">{{ translate('next_step') }}</van-button>
			</div>
			
		</van-form>

	</div>
</template>

<script>

	export default {
		name: 'account_bank',
		data() {

			let translate = this.translate

			return {
				formItem: {
					bank_id: "",
					bank_name: "",
					bank_branch: "",
					bank_number: "",
					bank_front_pic: "",
				},

				rules: {
					bank_id: [
						{
							required: true,
							message: translate('please_select'),
							trigger: 'onBlur'
						}
					],

					bank_name: [
						{
							required: true,
							message: translate('please_input'),
							trigger: 'onBlur'
						}
					],

					bank_branch: [
						{
							required: true,
							message: translate('please_input'),
							trigger: 'onBlur'
						}
					],
					
					bank_number: [
						{
							required: true,
							message: translate('please_input'),
							trigger: 'onBlur'
						}
					],
				},

				token: "",
				
				showBank: false,

				resourceURL: this.$axios.defaults.resourceURL,
				
				bank_front_url: this.$axios.defaults.resourceURL + "images/icon_bank_add.png",
				
				indexBank: -1,
				banks: [],

				disabledSubmit: true,
				
			}
		},
		mounted() {
			
			if (this.$route.query.token == "" || this.$route.query.token == undefined) {
				this.$router.replace('/nologin')
			} else {
				this.token = this.$route.query.token
				
				// 将方法绑定到window下面，提供给外部调用
				window.set_bank_front_pic = this.set_bank_front_pic
				
				this.init()
			}
		},
		methods: {
			init(){
				this.$axios({
					method: 'post',
					url: 'account_open/banks'
				}).then ((res) => {
					if (res.success) {

						this.banks = res.data

						// this.banks.push({
						// 	bank_id: 0,
						// 	text: '其他'
						// })
						
					}else{
						this.$toast.fail(res.error_text)
					}
				})
				
				this.$axios({
					method: 'post',
					url: 'account_open/info',
					data: {
						token: this.token
					}
				}).then ((res) => {
					if (res.success) {

						if (res.data.status == 2) {
							//	待审核
							this.$router.replace('/account/success')
						} else if (res.data.status == 3) {
							//	不通过
							this.$router.replace('/account/fail?token=' + this.token)
						} else {
							
							var bank_data = res.data.bank_data		
							
							if (bank_data.length != 0) {
								this.formItem.bank_id = bank_data.bank_id ? bank_data.bank_id : ""
								this.formItem.bank_name = bank_data.bank_name ? bank_data.bank_name : ""
								this.formItem.bank_branch = bank_data.bank_branch ? bank_data.bank_branch : ""
								this.formItem.bank_number = bank_data.bank_number ? bank_data.bank_number : ""
								this.formItem.bank_front_pic = bank_data.bank_front_pic ? bank_data.bank_front_pic : ""
								
								if (bank_data.bank_front_url) {
									this.bank_front_url = bank_data.bank_front_url
								}

								this.banks.forEach((item, key) => {
									if(item.bank_id == bank_data.bank_id){
										this.indexBank = key
									}								
								})
							}

						}

					}else{
						this.$toast.fail(res.error_text)
					}
				})

				
			},

			call_bank_front_pic(){
                if (window.JsObject != null) {
                    window.JsObject.callBankPic();
                }

				if(window.bank_front_pic != null){
					window.bank_front_pic.postMessage(
						'bank_front_pic'
					);
				}

                if (window.webkit.messageHandlers.jsToOcWithPrams != null) {
                    window.webkit.messageHandlers.jsToOcWithPrams.postMessage({"camera": "bank_front_pic"});
                }
			},
			
			/*   
             * 参数path：
             *     上传图片在服务器的路径
             */
            set_bank_front_pic(path){

				this.$axios({
					method: 'post',
					url: 'account_open/resize',
					data: {
						img: path
					}
				}).then ((res) => {
					if (res.success) {
						this.bank_front_url = res.thumb
						this.formItem.bank_front_pic = path
					}else{
						this.$toast.fail(this.translate('shoot_fail'))
					}
				})
			},
			onConfirmBank(item, index) {

				if (item) {
					this.indexBank = index

					this.formItem.bank_id = item.id			
					this.formItem.bank_name = item.name
				}
				
				this.showBank = false
			},
			nextStep(){

				if(this.formItem.bank_front_pic == '') {
					this.$toast.fail(this.translate('please_upload_bank_pic'))
					return false
				}
				
				this.$axios({
					method: 'post',
					url: 'account_open/update',
					data: {
						token: this.token,
						bank_data: JSON.stringify(this.formItem)
					}
				}).then ((res) => {
					if (res.success) {
						this.$router.push('/account/success')
					}else{
						this.$toast.fail(res.error_text)
					}
				})
				
			}
		},
	}
</script>